import { inject, Injectable, signal } from '@angular/core';
// eslint-disable-next-line no-restricted-imports
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import * as data from '@assets/icons.json';

const ICON_PAGE_BATCH = 100;

@Injectable({
  providedIn: 'root',
})
export class MaterialIconsService {
  readonly #iconRegistry = inject(MatIconRegistry);
  readonly #sanitizer = inject(DomSanitizer);

  readonly #iconsList = signal<{ icons: string[] }>(data['default']);
  readonly #icons = signal<string[]>([]);

  readonly icons = this.#icons.asReadonly();
  readonly iconList = this.#iconsList.asReadonly();

  addInitialIcons(): void {
    this.#iconRegistry.addSvgIconSetInNamespace(
      'mdi',
      this.#sanitizer.bypassSecurityTrustResourceUrl('assets/icons/mdi-icons.svg'),
    );
    this.#iconRegistry.addSvgIconSetInNamespace(
      'widgets',
      this.#sanitizer.bypassSecurityTrustResourceUrl('assets/icons/widget-icons.svg'),
    );
    this.#iconRegistry.addSvgIconSetInNamespace(
      'builder',
      this.#sanitizer.bypassSecurityTrustResourceUrl('assets/icons/builder-icons.svg'),
    );
  }

  getIconsWithPagination(page: number, list: string[]): string[] {
    const start = (page - 1) * ICON_PAGE_BATCH;
    const stop = Math.min(page * ICON_PAGE_BATCH, list.length);

    return list.slice(start, stop);
  }
}
